
ko.bindingHandlers.selectex = {
    init: function (element, valueAccessor, allBindings, viewModel, context) {
        const config = ko.unwrap(valueAccessor());

        new SelectEx(config);
    },
    update: function (element, valueAccessor, allBindings, viewModel, context) {
    }
};

class SelectEx {
    constructor(config) {
        this.config = config;

        /** @type {HTMLBaseElement} */
        this.targetEl = typeof config.target === 'string' ?
            document.querySelector(config.target) :
            config.target;

        if (!this.targetEl) {
            console.error('Target element not found.');
        }

        this.renderOptionCallback = this.config.onRenderOption ? this.config.onRenderOption : this.createDefaultOptionElement.bind(this);
        this.renderSelectCallback = this.config.onRenderSelect ? this.config.onRenderSelect : this.createDefaultOptionElement.bind(this);

        this.rootEl = makeEl('div', {
            style: {
                position: 'relative'
            }
        });
        this.selectRootEl = document.createElement('div');
        this.dropdownRootEl = makeEl('div', {
            style: {
                position: 'absolute'
            }
        });

        this.rootEl.appendChild(this.selectRootEl);
        this.rootEl.appendChild(this.dropdownRootEl);

        this.backdropEl = makeEl('div', {
            style: {
                position: 'fixed',
                left: 0,
                right: 0,
                bottom: 0,
                top: 0,
                zIndex: 999
            },
            onClick: () => {
                this.hideDropdown();
            }
        })

        this.init();
    }

    init() {
        this.targetEl.style.display = 'none';
        this.targetEl.parentElement.appendChild(this.rootEl);

        this.onTargetChanged = this.onTargetChanged.bind(this);
        this.targetEl.addEventListener('change', this.onTargetChanged);

        this.selectObserver = new MutationObserver((mutations) => {
            mutations.forEach(mutation => {
                const attribute = mutation.attributeName;
                const addedOpts = mutation.addedNodes;
                const removedOpts = mutation.removedOpts;

                console.log('CHN', attribute, addedOpts, removedOpts);

                if (addedOpts) {
                    addedOpts.forEach(opt => {
                        this.addOption(opt.value, opt.text);
                    });
                }
            });
        });
        this.selectObserver.observe(this.targetEl, {
            attributes: true,
            subtree: true,
            childList: true
        });

        this.setSelectSelectedValue(this.targetEl.value);
    }

    onTargetChanged(e) {
        console.log('ORIG CHANGED', e.target.value);
        this.setSelectSelectedValue(e.target.value);
    }

    setSelectSelectedValue(val) {
        console.log('AAA', val);
        const selEl = this.renderSelectCallback(val, this.getOriginalTextByVal(val));

        this.selectRootEl.innerHTML = '';
        this.selectRootEl.appendChild(selEl);
    }

    getOriginalTextByVal(val) {
        const foundVals = Array.from(this.targetEl.children).filter(i => i.value == val);

        if (foundVals.length > 0) return foundVals[0].text;

        return val;
    }

    showDropdown() {
        document.body.appendChild(this.backdropEl);
        document.body.appendChild(this.dropdownRootEl);
    }

    hideDropdown() {
        document.body.removeChild(this.backdropEl);
        document.body.removeChild(this.dropdownRootEl);
    }

    addOption(value, text) {
        const optEl = this.createOption(value, text);

        optEl._selectexValue = value;

        this.dropdownRootEl.appendChild(optEl);
    }

    createOption(value, text) {
        return this.renderOptionCallback(value, text);
    }

    createDefaultOptionElement(value, text) {
        let templateEl = document.createElement('div');

        return templateEl;
    }

    dispose() {
        this.selectObserver.disconnect();
    }
}


/**
 * 
 * @param {string} tag 
 * @param {any} attrs 
 * @param {Array<HTMLBaseElement>} textOrChildrenEl
 * @returns {HTMLBaseElement}
 */
export function makeEl(tag, attrs, ...textOrChildrenEl) {
    return adjustEl(document.createElement(tag), attrs, ...textOrChildrenEl)
}

/**
 * 
 * @param {string|HTMLBaseElement} selector 
 * @param {any} attrs 
 * @param {Array<HTMLBaseElement>} textOrChildrenEl
 * @returns {HTMLBaseElement}
 */
export function adjustEl(selectorOrEl, attrs, ...textOrChildrenEl) {
    let el = null;
    
    if (typeof selectorOrEl === 'string') {
        el = document.querySelector(selectorOrEl);
    } else {
        el = selectorOrEl;
    }

    const eventNames = ['onclick', 'onchange', 'keydown', 'keyup'];

    /*if (typeof attrs === 'string') {
        el.className = attrs;
    } else*/ if (typeof attrs === 'object') {
        for (let key in attrs) {
            if (eventNames.indexOf(key.toLowerCase()) !== -1) {
                const origKey = key;
                if (key.startsWith('on')) key = key.substr(2);
                el.addEventListener(key.toLowerCase(), attrs[origKey]);

                continue;
            }

            const attr = getParameterCaseInsensitive(el, key);

            if (attr.key) {
                if (attr.key === 'style') {
                    Object.assign(el[attr.key], attrs[key]);
                } else {
                    el[attr.key] = attrs[key] || null;
                }
            } else {
                el.setAttribute(key, attrs[key]);
            }
        }
    }

    if (textOrChildrenEl) {
        iterateChildren(textOrChildrenEl);
    }

    function iterateChildren(...children) {
        for (let child of children) {
            if (!child) {
                continue;
            } else if (typeof child === 'string') {
                let txt = document.createTextNode(child);
                el.appendChild(txt);
                //el.textContent = textOrChildrenEl;
            } else if (Array.isArray(child)) {
                iterateChildren(...child);
            } else {
                el.appendChild(child);
            }
        }
    }

    function getParameterCaseInsensitive(object, key) {
        let origKey = null;
        let origVal = null;

        for (let k in object) {
            if (k.toLowerCase() === key.toLowerCase()) {
                origKey = k;
                origVal = object[k];
            }
        }

        return { key: origKey, val: origVal };
    }

    return el;
}